module.exports = __webpack_public_path__ + "img/double.72c1fe88.png";